import axios from 'axios';
import { 
  Grantha, 
  GranthaL1, 
  GranthaL2, 
  GranthaL3, 
  GranthaL4, 
  GranthaL5,
  BulkCreateL1,
  BulkCreateL2,
  BulkCreateL3,
  BulkCreateL4,
  BulkCreateL5,
  GranthaSloka,
  Language,
  Country,
  SankalpaLineBhed,
  BidhiLineBhed,
  Vyakhyanuvad,
  VyakhyanuvadWithDetails,
  SingleCreateL1,
  SingleCreateL2,
  SingleCreateL3,
  SingleCreateL4,
  SingleCreateL5,
  User,
  Policy,
  Effect,
  ShlokaWithVyakhyanuvad,
  Upodghat,
  ReferenceYJS,
  Sankalpa,
  CreateSankalpa,
  Puja,
  CreatePuja,
  Samagri,
  CreateSamagri,
  Panchanga
} from '../types';
import type { BookDefaultStylesV1 } from '../utils/bookDefaults';

// // const API_URL = 'http://localhost:3000';
// export const API_URL = 'http://147.124.221.94:3000'

// export const API_URL = "http://192.168.1.175:3000"

export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://elibapidev.vag.org.np'
    : 'http://localhost:3000';
  //:'https://elibapidev.vag.org.np';
  // : 'http://104.37.174.214:3000';


// Must match axios baseURL so /uploads/* image paths resolve correctly in dev.

const api = axios.create({
  baseURL: API_URL,
});

// Add request interceptor to include JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('Error response:', error.response?.data);
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Grantha API calls
export const granthaApi = {
  getAll: () => api.get<Grantha[]>('/grantha'),
  getById: (id: number) => api.get<Grantha>(`/grantha/${id}`),
  create: (grantha: any) => {
    if (grantha instanceof FormData) {
      return api.post<Grantha>('/grantha', grantha, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.post<Grantha>('/grantha', grantha);
  },
  update: (id: number, grantha: any) => {
    if (grantha instanceof FormData) {
      return api.patch<Grantha>(`/grantha/${id}`, grantha, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.patch<Grantha>(`/grantha/${id}`, grantha);
  },
  delete: (id: number) => api.delete(`/grantha/${id}`),
  searchShlokas: (granthaId: number, text: string, languageId: number) =>
    api.get(`/grantha/${granthaId}/shloka/search`, { params: { text, languageId } }),
};

// GranthaL1 API calls
export const granthaL1Api = {
  getAllByGranthaId: (granthaId: number) => api.get<GranthaL1[]>(`/grantha-l1/grantha/${granthaId}`),
  getById: (id: number) => api.get<GranthaL1>(`/grantha-l1/${id}`),
  update: (id: number, l1: Partial<GranthaL1>) => api.patch<GranthaL1>(`/grantha-l1/${id}`, l1),
  delete: (id: number) => api.delete(`/grantha-l1/${id}`),
  bulkCreate: (data: BulkCreateL1) => api.post('/grantha-l1/bulk', data),
  singleCreate: (data: SingleCreateL1) => api.post(`/grantha-l1/single`, data),
};

// GranthaL2 API calls
export const granthaL2Api = {
  getAllByL1Id: (l1Id: number) => api.get<GranthaL2[]>(`/grantha-l2/l1/${l1Id}`),
  getById: (id: number) => api.get<GranthaL2>(`/grantha-l2/${id}`),
  update: (id: number, l2: Partial<GranthaL2>) => api.patch<GranthaL2>(`/grantha-l2/${id}`, l2),
  delete: (id: number) => api.delete(`/grantha-l2/${id}`),
  bulkCreate: (data: BulkCreateL2) => api.post('/grantha-l2/bulk', data),
  singleCreate: (data: SingleCreateL2) => api.post(`/grantha-l2/single`, data),
};

// GranthaL3 API calls
export const granthaL3Api = {
  getAllByL2Id: (l2Id: number) => api.get<GranthaL3[]>(`/grantha-l3/l2/${l2Id}`),
  getById: (id: number) => api.get<GranthaL3>(`/grantha-l3/${id}`),
  update: (id: number, l3: Partial<GranthaL3>) => api.patch<GranthaL3>(`/grantha-l3/${id}`, l3),
  delete: (id: number) => api.delete(`/grantha-l3/${id}`),
  bulkCreate: (data: BulkCreateL3) => api.post('/grantha-l3/bulk', data),
  singleCreate: (data: SingleCreateL3) => api.post(`/grantha-l3/single`, data),
};

// GranthaL4 API calls
export const granthaL4Api = {
  getAllByL3Id: (l3Id: number) => api.get<GranthaL4[]>(`/grantha-l4/l3/${l3Id}`),
  getById: (id: number) => api.get<GranthaL4>(`/grantha-l4/${id}`),
  update: (id: number, l4: Partial<GranthaL4>) => api.patch<GranthaL4>(`/grantha-l4/${id}`, l4),
  delete: (id: number) => api.delete(`/grantha-l4/${id}`),
  bulkCreate: (data: BulkCreateL4) => api.post('/grantha-l4/bulk', data),
  singleCreate: (data: SingleCreateL4) => api.post(`/grantha-l4/single`, data),
};

// GranthaL5 API calls
export const granthaL5Api = {
  getAllByL4Id: (l4Id: number) => api.get<GranthaL5[]>(`/grantha-l5/l4/${l4Id}`),
  getById: (id: number) => api.get<GranthaL5>(`/grantha-l5/${id}`),
  update: (id: number, l5: Partial<GranthaL5>) => api.patch<GranthaL5>(`/grantha-l5/${id}`, l5),
  delete: (id: number) => api.delete(`/grantha-l5/${id}`),
  bulkCreate: (data: BulkCreateL5) => api.post('/grantha-l5/bulk', data),
  singleCreate: (data: SingleCreateL5) => api.post(`/grantha-l5/single`, data),
};

// GranthaSloka API calls
export const shlokaApi = {
  getAll: () => api.get<GranthaSloka[]>('/grantha-shloka'),
  getById: (id: number) => api.get<GranthaSloka>(`/grantha-shloka/${id}`),
  getByGranthaId: (granthaId: number) => api.get<GranthaSloka[]>(`/grantha-shloka/grantha/${granthaId}`),
  getByLevel: (granthaId: number, level: string, levelId: number) => 
    api.get<GranthaSloka[][]>(`/grantha-shloka/grantha/${granthaId}/level/${level}/${levelId}`),
  getByLevelWithLanguage: (granthaId: number, level: string, levelId: number, languageId: number) => 
    api.get<GranthaSloka[]>(`/grantha-shloka/grantha/${granthaId}/level/${level}/${levelId}/language/${languageId}`),
  getByLevelWithVyakhyanuvad: (granthaId: number, level: string, levelId: number, languageId: number, vyakhyanuvadId: number) => 
    api.get<ShlokaWithVyakhyanuvad[]>(`/grantha-shloka/withvyakhyanuvad/grantha/${granthaId}/level/${level}/${levelId}/language/${languageId}/vyakhyanuvadId/${vyakhyanuvadId}`),
  getByGranthaShlokaNumberAndLanguage: (granthaId: number, shlokaCount: number, languageId: number) => 
    api.get<GranthaSloka[]>(`/grantha-shloka/grantha/${granthaId}/shloka/${shlokaCount}/language/${languageId}`),
  create: (shloka: GranthaSloka) => api.post<GranthaSloka>('/grantha-shloka', shloka),
  updateAnvaya: (shlokaNumberId: number, padachhedIds: string[]) => 
    api.post('/anvaya', { shlokaNumberId, padachhedIds }),
  delete: (shlokaNumberId: number) => api.delete(`/grantha-shloka/${shlokaNumberId}`),
  deleteLink: (shlokaNumberId: number) => api.delete(`/grantha-shloka/link/${shlokaNumberId}`),
  createLine: (line: { granthaId: number; parent_level: string; parent_level_id: number; shloka_count: number; shlokaNumberId: number; line_text: string; line_order: number; rishi?: string; devta?: string; chanda?: string; swor?: string; tag?: string }) => 
    api.post('/grantha-shloka/line', line),
  updateLine: (id: number, line: { line_text: string; rishi?: string; devta?: string; chanda?: string; swor?: string; tag?: string }) => 
    api.patch(`/grantha-shloka/${id}`, line),
  deleteLine: (id: number) => api.delete(`/grantha-shloka/line/${id}`),
  deleteLinkLine: (linkId: number, lineId: number, levelShlokaNumber?: number, order?: number) => 
    api.delete(`/grantha-shloka/link/line`, { data: { linkId, lineId, levelShlokaNumber, order } }),
  updateLinkLine: (linkId: number, lineId: number, order: number, line: { line_text: string; rishi?: string; devta?: string; chanda?: string; swor?: string; tag?: string }) => 
    api.patch(`/grantha-shloka/link/${linkId}/line/${lineId}/order/${order}`, line),
  link: (payload: {
    inside: {
      granthaId: string;
      parent_level: string;
      parent_level_id: string;
      shloka_count: string;
    };
    copy: {
      bhavartha: boolean;
      vyakhya: boolean;
      paddachhed: boolean;
      padartha: boolean;
      hyperlinks: boolean;
      vyakhyanuvad: boolean;
    };
    lines: {
      granthaId: string;
      parent_level: string;
      parent_level_id: string;
      shloka_count_id: string;
      order: string;
      level_shloka_number: string;
    }[];
  }) => api.post('/grantha-shloka/link', payload),
  addMetadata: (shlokaNumberId: number, metadata: Record<string, string>) => 
    api.post(`/grantha-shloka/metadata/${shlokaNumberId}`, metadata),
  deleteMetadata: (shlokaNumberId: number, key: string) => 
    api.delete(`/grantha-shloka/metadata/${shlokaNumberId}/key/${key}`),
  deleteShlokaSearchable: (shlokaCountId: number, key: string) => 
    api.delete(`/grantha-shloka/searchable/${shlokaCountId}/key/${key}`),
  addShlokaSearchable: (shlokaCountId: number, searchableArray: string[]) => 
    api.post(`/grantha-shloka/searchable/${shlokaCountId}`, searchableArray),
  updatePratik: (shlokaCountId: number, data: { pratik?: string; sar_pratik?: string }) => 
    api.patch(`/grantha-shloka/pratik/${shlokaCountId}`, data),
};



// Padachhed API calls
export const padachhedApi = {
  create: (padachhed: { shlokaNumberId: number; text: string; sar_text?: string; searchable?: string[]; order: number }) => 
    api.post('/padachhed', padachhed),
  update: (id: number, padachhed: { text: string; sar_text?: string; searchable?: string[] }) => 
    api.patch(`/padachhed/${id}`, padachhed),
  delete: (id: number) => api.delete(`/padachhed/${id}`),
  getByShlokaNumberId: (shlokaNumberId: number) => 
    api.get(`/padachhed/shloka/${shlokaNumberId}`),
  bulkUpdateOrder: (orders: { padachhedId: number; changedOrder: number }[]) => 
    api.patch('/padachhed/bulk-order', orders),
};

// Extra Anvaya API calls
export const extraAnvayaApi = {
  create: (extraAnvaya: { shlokaNumberId: number; text: string; order: number }) => 
    api.post('/extra-anvaya', extraAnvaya),
  update: (id: number, extraAnvaya: { text: string; order: number }) => 
    api.patch(`/extra-anvaya/${id}`, extraAnvaya),
  getByShlokaNumber: (shlokaNumber: number) => 
    api.get(`/extra-anvaya/shloka/${shlokaNumber}`),
  updateBulkOrder: (orders: { id: number; order: number }[]) => 
    api.patch('/extra-anvaya/bulk-order', orders),
  delete: (id: number) => api.delete(`/extra-anvaya/${id}`),
};

// Language API calls
export const languageApi = {
  getAll: () => api.get<Language[]>('/language'),
  getById: (id: number) => api.get<Language>(`/language/${id}`),
  create: (language: Language) => api.post<Language>('/language', language),
  update: (id: number, language: Partial<Language>) => api.patch<Language>(`/language/${id}`, language),
  delete: (id: number) => api.delete(`/language/${id}`),
};

// Country API calls
export const countryApi = {
  getAll: () => api.get<Country[]>('/country'),
  getById: (id: number) => api.get<Country>(`/country/${id}`),
  create: (country: Pick<Country, 'name'>) => api.post<Country>('/country', country),
  update: (id: number, country: Pick<Country, 'name'>) => api.patch<Country>(`/country/${id}`, country),
  delete: (id: number) => api.delete(`/country/${id}`),
};

// Sankalpa Line Bhed API calls
export const sankalpaLineBhedApi = {
  getBySankalpaLineId: (sankalpaLineId: number) =>
    api.get<SankalpaLineBhed[]>('/sankalpa-line-bhed', { params: { sankalpaLineId } }),
  getById: (id: number) => api.get<SankalpaLineBhed>(`/sankalpa-line-bhed/${id}`),
  create: (payload: {
    sankalpaLineId: number;
    text: string;
    languageId: number;
    countryId: number;
  }) => api.post<SankalpaLineBhed>('/sankalpa-line-bhed', payload),
  update: (
    id: number,
    payload: Partial<Pick<SankalpaLineBhed, 'text' | 'languageId' | 'countryId'>>,
  ) => api.patch<SankalpaLineBhed>(`/sankalpa-line-bhed/${id}`, payload),
  delete: (id: number) => api.delete(`/sankalpa-line-bhed/${id}`),
};

// Bidhi Line Bhed API calls
export const bidhiLineBhedApi = {
  getByBidhiLineId: (bidhiLineId: number) =>
    api.get<BidhiLineBhed[]>('/bidhi-line-bhed', { params: { bidhiLineId } }),
  getById: (id: number) => api.get<BidhiLineBhed>(`/bidhi-line-bhed/${id}`),
  create: (payload: {
    bidhiLineId: number;
    text: string;
    languageId: number;
  }) => api.post<BidhiLineBhed>('/bidhi-line-bhed', payload),
  update: (
    id: number,
    payload: Partial<Pick<BidhiLineBhed, 'text' | 'languageId'>>,
  ) => api.patch<BidhiLineBhed>(`/bidhi-line-bhed/${id}`, payload),
  delete: (id: number) => api.delete(`/bidhi-line-bhed/${id}`),
};



// Bhavartha API calls
export const bhavarthaApi = {
  create: (bhavartha: { shlokaNumberId: number; text: string; languageId: number }) => 
    api.post('/bhavartha', bhavartha),
  update: (id: number, bhavartha: { text: string }) => 
    api.patch(`/bhavartha/${id}`, bhavartha),
  delete: (id: number) => api.delete(`/bhavartha/${id}`),
};

// Vyakhya API calls
export const vyakhyaApi = {
  create: (vyakhya: { shlokaNumberId: number; text: string; languageId: number }) => 
    api.post('/vyakhya', vyakhya),
  update: (id: number, vyakhya: { text: string }) => 
    api.patch(`/vyakhya/${id}`, vyakhya),
  delete: (id: number) => api.delete(`/vyakhya/${id}`),
};

// Padachhed Padartha API calls
export const padachhedPadarthaApi = {
  create: (padartha: { padachhedId: number; text: string; languageId: number }) => 
    api.post('/padachhed-padartha', padartha),
  update: (padartha: { id: number; text: string }) => 
    api.patch('/padachhed-padartha', padartha),
  delete: (id: number) => api.delete(`/padachhed-padartha/${id}`),
};

// Extra Anvaya Padartha API calls
export const extraAnvayaPadarthaApi = {
  create: (padartha: { extraAnvayaId: number; text: string; languageId: number }) => 
    api.post('/extra-anvaya-padartha', padartha),
  update: (padartha: { id: number; text: string }) => 
    api.patch('/extra-anvaya-padartha', padartha),
  delete: (id: number) => api.delete(`/extra-anvaya-padartha/${id}`),
};

// Profile API calls
export const profileApi = {
  getAll: () => api.get('/profile'),
  getById: (id: number) => api.get(`/profile/${id}`),
  create: (profile: any) => {
    if (profile instanceof FormData) {
      return api.post('/profile', profile, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.post('/profile', profile, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  },
  update: (id: number, profile: any) => api.patch(`/profile/${id}`, profile),
  delete: (id: number) => api.delete(`/profile/${id}`),
};

// Role API calls
export const roleApi = {
  getAll: () => api.get('/role'),
  getById: (id: number) => api.get(`/role/${id}`),
  create: (role: { name: string }) => api.post('/role', role),
  update: (id: number, role: { name: string }) => api.patch(`/role/${id}`, role),
  delete: (id: number) => api.delete(`/role/${id}`),
};

// Grantha Role Association API calls
export const granthaRoleAssociationApi = {
  create: (association: { profileId: number; roleId: number; granthaId: number }) => 
    api.post('/grantha-role-association', association),
  delete: (id: number) => api.delete(`/grantha-role-association/${id}`),
};

// Vyakhyanuvad Role Association API calls
export const vyakhyanuvadRoleAssociationApi = {
  create: (association: { profileId: number; roleId: number; vyakhyanuvadId: number }) => 
    api.post('/vyakhyanuvad-role-association', association),
  delete: (id: number) => api.delete(`/vyakhyanuvad-role-association/${id}`),
};

// Bidhi Role Association API calls
export const bidhiRoleAssociationApi = {
  create: (association: { profileId: number; roleId: number; bidhiId: number }) =>
    api.post('/bidhi-role-association', association),
  delete: (id: number) => api.delete(`/bidhi-role-association/${id}`),
};

// Vyakhyanuvad API calls
export const vyakhyanuvadApi = {
  getAll: () => api.get<Vyakhyanuvad[]>('/vyakhyanuvad'),
  getById: (id: number) => api.get<Vyakhyanuvad>(`/vyakhyanuvad/${id}`),
  getByGranthaIdVyakhyanuvadId: (granthaId: number, vyakhyanuvadId: number) => api.get<VyakhyanuvadWithDetails>(`/vyakhyanuvad/grantha/${granthaId}/vyakhyanuvad/${vyakhyanuvadId}`),
  getByGranthaId: (granthaId: number) => api.get<Vyakhyanuvad[]>(`/vyakhyanuvad/grantha/${granthaId}`),
  create: (vyakhyanuvad: { name: any; granthaId: any; languageId: any; metadata: Record<any, any>; }) => api.post<Vyakhyanuvad>('/vyakhyanuvad', vyakhyanuvad),
  update: (id: number, vyakhyanuvad: Partial<Vyakhyanuvad>) => api.patch<Vyakhyanuvad>(`/vyakhyanuvad/${id}`, vyakhyanuvad),
  delete: (id: number) => api.delete(`/vyakhyanuvad/${id}`),
};

// Vyakhyanuvad Text API calls
export const vyakhyanuvadTextApi = {
  create: (vyakhyanuvadText: { shlokaNumberId: number; vyakhyanuvadId: number; text: string }) => 
    api.post('/vyakhyanuvad-text', vyakhyanuvadText),
  update: (id: number, vyakhyanuvadText: { text: string }) => 
    api.put(`/vyakhyanuvad-text/${id}`, vyakhyanuvadText),
  updateUpodghat: (id: number, upodghat: Partial<Upodghat>) => 
    api.put(`/vyakhyanuvad-text/${id}/upodghat`, upodghat),
  delete: (id: number) => api.delete(`/vyakhyanuvad-text/${id}`),
  getByShlokaAndVyakhyanuvad: (shlokaNumberId: number, vyakhyanuvadId: number) => 
    api.get(`/vyakhyanuvad-text/shloka/${shlokaNumberId}/vyakhyanuvad/${vyakhyanuvadId}`),
};

// Vyakhyanuvad Translation API calls
export const vyakhyanuvadTranslationApi = {
  create: (vyakhyanuvadTranslation: { shlokaNumberId: number; vyakhyanuvadTextId: number; text: string; languageId: number }) => 
    api.post('/vyakhyanuvad-translation', vyakhyanuvadTranslation),
  update: (id: number, vyakhyanuvadTranslation: { text: string }) => 
    api.put(`/vyakhyanuvad-translation/${id}`, vyakhyanuvadTranslation),
  delete: (id: number) => api.delete(`/vyakhyanuvad-translation/${id}`),
  getByShlokVyakhyanuvadAndLanguage: (shlokaNumberId: number, vyakhyanuvadId: number, languageId: number) => 
    api.get(`/vyakhyanuvad-translation/shloka/${shlokaNumberId}/vyakhyanuvad/${vyakhyanuvadId}/language/${languageId}`),
};

// Auth API calls
export const authApi = {
  login: (credentials: { username: string; password: string }) => 
    api.post('/auth/login', credentials),
};

// User API calls
export const userApi = {
  getAll: () => api.get<User[]>('/auth'),
  create: (user: { username: string; email: string; password: string }) => api.post<User>('/auth', user),
  update: (id: number, user: Partial<User>) => api.patch<User>(`/auth/${id}`, user),
  resetPassword: (username: string, newPassword: string) => api.post('/auth/reset-password', { username, newPassword }),
  delete: (id: number) => api.delete(`/auth/${id}`),
  deactivate: (id: number) => api.patch(`/auth/${id}/deactivate`, {}),
  activate: (id: number) => api.patch(`/auth/${id}/activate`, {}),
  assignPolicy: (userId: number, policyId: number) => api.post('/auth/assign-policy', { userId, policyId }),
};

// Policy API calls
export const policyApi = {
  getAll: () => api.get<Policy[]>('/auth/policy'),
  create: (policy: { name: string; effect: Effect; action: string; resource: string }) => api.post<Policy>('/auth/policy', policy),
  update: (id: number, policy: { name: string; effect: Effect; action: string; resource: string }) => api.patch<Policy>(`/auth/policy/${id}`, policy),
  delete: (id: number) => api.delete(`/auth/policy/${id}`),
};

// Reference API calls
export const referenceApi = {
  create: (reference: ReferenceYJS) => api.post<ReferenceYJS>('/references', reference),
  update: (id: number, reference: Partial<ReferenceYJS>) => api.patch<ReferenceYJS>(`/references/${id}`, reference),
  delete: (id: number) => api.delete(`/references/${id}`),
};

//Bidhi API Calls
export const karmakandaAPI = {
  createBidhi: (bidhi: any) => api.post('/bidhi', bidhi),
  updateBidhi: (id: number, bidhi: any) => api.patch(`/bidhi/${id}`, bidhi),
  getAllBidhis: () => api.get('/bidhi'),
  getRootsBidhis: () => api.get('/bidhi/roots'),
  getBidhiById: (id: number) => api.get(`/bidhi/${id}`),
  deleteBidhiById: (id: number) => api.delete(`/bidhi/${id}`),
  addParent: (childId: number, parentId: number, data: { order: number, startingPosition: number, lineId: number, selectedBidhiLineIds: Array<number>, entireBidhi: boolean }) => 
    api.post(`/bidhi/${childId}/parent/${parentId}`, data),
  removeParent: (childId: number, parentId: number, lineId: number) => 
    api.delete(`/bidhi/${childId}/parent/${parentId}`, { data: { lineId } }),
  createGranthaReference: (dto: any) => api.post('/bidhi/grantha-reference', dto),
  updateGranthaReference: (id: number, dto: any) => 
    api.patch(`/bidhi/grantha-reference/${id}`, dto),
  deleteGranthaReference: (id: number) => api.delete(`/bidhi/grantha-reference/${id}`),
  createBidhiHyperlinkBidhi: (dto: {
    bidhiId: number;
    lineId: number;
    startPosition: number;
    endingPosition: number;
    shortcut?: boolean;
    references: { bidhiId: number }[];
  }) => api.post('/bidhi/bidhi-hyperlink-bidhi', dto),
  updateBidhiHyperlinkBidhi: (id: number, dto: Partial<{
    startPosition: number;
    endingPosition: number;
    shortcut: boolean;
    references: { bidhiId: number }[];
  }>) => api.patch(`/bidhi/bidhi-hyperlink-bidhi/${id}`, dto),
  deleteBidhiHyperlinkBidhi: (id: number) =>
    api.delete(`/bidhi/bidhi-hyperlink-bidhi/${id}`),
  createBidhiHyperlinkSankalpa: (dto: {
    bidhiId: number;
    lineId: number;
    startPosition: number;
    endingPosition: number;
    shortcut?: boolean;
    references: { sankalpaId: number }[];
  }) => api.post('/bidhi/bidhi-hyperlink-sankalpa', dto),
  updateBidhiHyperlinkSankalpa: (id: number, dto: Partial<{
    startPosition: number;
    endingPosition: number;
    shortcut: boolean;
    references: { sankalpaId: number }[];
  }>) => api.patch(`/bidhi/bidhi-hyperlink-sankalpa/${id}`, dto),
  deleteBidhiHyperlinkSankalpa: (id: number) =>
    api.delete(`/bidhi/bidhi-hyperlink-sankalpa/${id}`),
  addLines: (id: number, lines: { content: string; order: number; isVisible?: boolean; link_only_line?: boolean; metadata?: Record<string, string> }[]) => 
    api.post(`/bidhi/line/${id}`, lines),
  updateLine: (lineId: number, data: { content?: string; order?: number; isVisible?: boolean; link_only_line?: boolean; metadata?: Array<any> }) => 
    api.patch(`/bidhi/line/${lineId}`, data),
  deleteLine: (bidhiId: number, lineId: number) => 
    api.delete(`/bidhi/line/${lineId}`),
  bulkUpdateBidhiLineOrder: (updates: { bidhiLineId: number; changedOrder: number }[]) =>
    api.patch('/bidhi/lines/bulk-order', updates),
};

export type PujaStyleTemplate = {
  id: number;
  name: string;
  styles: BookDefaultStylesV1 & {
    bookOverrides?: Record<string, any>;
  };
  isActive?: boolean;
  updatedAt?: string;
};

export type PujaStyleTemplatesListResponse = {
  templates: PujaStyleTemplate[];
  activeTemplateId?: number | null;
};

export const pujaStyleTemplatesApi = {
  list: () => api.get<PujaStyleTemplatesListResponse>('/puja-style-templates'),
  create: (payload: { name: string; styles: PujaStyleTemplate['styles'] }) =>
    api.post<PujaStyleTemplate>('/puja-style-templates', payload),
  update: (
    id: number,
    payload: { name?: string; styles?: PujaStyleTemplate['styles']; isActive?: boolean },
  ) => api.put<PujaStyleTemplate>(`/puja-style-templates/${id}`, payload),
  delete: (id: number) => api.delete<{ ok: true }>(`/puja-style-templates/${id}`),
};

// BidhiTag API Calls
export const bidhiTagAPI = {
  getAllBidhi: () => api.get('/bidhi-tag'),
  getBidhiById: (id: number) => api.get(`/bidhi-tag/${id}`),
  createTag: (tag: { name: string }) => api.post('/bidhi-tag', tag),
  updateTag: (id: number, tag: { name: string }) => api.patch(`/bidhi-tag/${id}`, tag),
  deleteTag: (id: number) => api.delete(`/bidhi-tag/${id}`),
  associateTagWithBidhi: (tagId: number, bidhiId: number) => api.post(`/bidhi-tag/${tagId}/bidhi/${bidhiId}`),
  removeTagFromBidhi: (tagId: number, bidhiId: number) => api.delete(`/bidhi-tag/${tagId}/bidhi/${bidhiId}`),
};

// Sankalpa API Calls
export const sankalpaApi = {
  getAll: () => api.get<Sankalpa[]>('/sankalpa'),
  getById: (id: number) => api.get<Sankalpa>(`/sankalpa/${id}`),
  create: (sankalpa: CreateSankalpa) => api.post<Sankalpa>('/sankalpa', sankalpa),
  update: (id: number, sankalpa: Partial<CreateSankalpa>) => api.patch<Sankalpa>(`/sankalpa/${id}`, sankalpa),
  delete: (id: number) => api.delete(`/sankalpa/${id}`),
  addLines: (id: number, lines: { content: string; order?: number; metadata?: Record<string, string> }[]) => 
    api.post(`/sankalpa/lines/${id}`, lines),
  updateLine: (lineId: number, data: { content: string; order?: number; metadata?: Record<string, string> }) => 
    api.patch(`/sankalpa/lines/${lineId}`, data),
  deleteLine: (lineId: number) => api.delete(`/sankalpa/lines/${lineId}`),
};

// SankalpaTag API Calls
export const sankalpaTagAPI = {
  getAll: () => api.get('/sankalpa-tag'),
  getById: (id: number) => api.get(`/sankalpa-tag/${id}`),
  createTag: (tag: { name: string }) => api.post('/sankalpa-tag', tag),
  updateTag: (id: number, tag: { name: string }) => api.patch(`/sankalpa-tag/${id}`, tag),
  deleteTag: (id: number) => api.delete(`/sankalpa-tag/${id}`),
  associateTagWithSankalpa: (tagId: number, sankalpaId: number) => api.post(`/sankalpa-tag/${tagId}/sankalpa/${sankalpaId}`),
  removeTagFromSankalpa: (tagId: number, sankalpaId: number) => api.delete(`/sankalpa-tag/${tagId}/sankalpa/${sankalpaId}`),
};

// Puja API Calls
export const pujaApi = {
  getAll: () => api.get<Puja[]>('/puja'),
  getById: (id: number) => api.get<Puja>(`/puja/${id}`),
  create: (puja: CreatePuja | FormData) => {
    if (puja instanceof FormData) {
      return api.post<Puja>('/puja', puja, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.post<Puja>('/puja', puja);
  },
  update: (id: number, puja: Partial<CreatePuja> | FormData) => {
    if (puja instanceof FormData) {
      return api.patch<Puja>(`/puja/${id}`, puja, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.patch<Puja>(`/puja/${id}`, puja);
  },
  delete: (id: number) => api.delete(`/puja/${id}`),
  addLines: (id: number, lines: { content: string; order?: number; metadata?: Record<string, string> }[]) => 
    api.post(`/puja/line/${id}`, lines),
  updateLine: (lineId: number, data: { content: string; order?: number; metadata?: Record<string, string>; isVisible?: boolean }) => 
    api.patch(`/puja/line/${lineId}`, data),
  deleteLine: (lineId: number) => api.delete(`/puja/line/${lineId}`),
  bulkUpdateLineOrder: (updates: { pujaLineId: number; changedOrder: number }[]) =>
    api.patch('/puja/lines/bulk-order', updates),
};

// PujaTag API Calls
export const pujaTagAPI = {
  getAll: () => api.get('/puja-tag'),
  getById: (id: number) => api.get(`/puja-tag/${id}`),
  createTag: (tag: { name: string }) => api.post('/puja-tag', tag),
  updateTag: (id: number, tag: { name: string }) => api.patch(`/puja-tag/${id}`, tag),
  deleteTag: (id: number) => api.delete(`/puja-tag/${id}`),
  associateTagWithPuja: (tagId: number, pujaId: number) => api.post(`/puja-tag/${tagId}/puja/${pujaId}`),
  removeTagFromPuja: (tagId: number, pujaId: number) => api.delete(`/puja-tag/${tagId}/puja/${pujaId}`),
};

// Puja Line Link API Calls
export const pujaLineLinkApi = {
  // Bidhi links
  createBidhiLink: (payload: { pujaLineId: number; bidhiId: number; position: number; order: number; entireBidhi?: boolean; selectedBidhiLineIds?: number[]; titleVisible?: boolean; shortcut?: boolean; displayName?: string }) =>
    api.post('/puja-line-link/bidhi', payload),
  getBidhiLinksByPujaLine: (pujaLineId: number) =>
    api.get(`/puja-line-link/bidhi/puja-line/${pujaLineId}`),
  deleteBidhiLink: (id: number) =>
    api.delete(`/puja-line-link/bidhi/${id}`),
  bulkUpdateBidhiLinkOrder: (updates: { pujaBidhiLinkId: number; changedOrder: number }[]) =>
    api.patch('/puja-line-link/bidhi/bulk-order', updates),

  // Sankalpa links
  createSankalpaLink: (payload: { pujaLineId: number; sankalpaId: number; position: number; selectedSankalpaLineIds?: number[]; titleVisible?: boolean }) =>
    api.post('/puja-line-link/sankalpa', payload),
  getSankalpaLinksByPujaLine: (pujaLineId: number) =>
    api.get(`/puja-line-link/sankalpa/puja-line/${pujaLineId}`),
  deleteSankalpaLink: (id: number) =>
    api.delete(`/puja-line-link/sankalpa/${id}`),

  // Grantha links
  createGranthaLink: (payload: { pujaLineId: number; granthaId: number; startingPosition: number; shortcut?: boolean }) =>
    api.post('/puja-line-link/grantha', payload),
  deleteGranthaLink: (id: number) =>
    api.delete(`/puja-line-link/grantha/${id}`),
};

// Bidhi Line Link API Calls (multiple bidhis per line position)
export const bidhiLineLinkApi = {
  createMultipleBidhiLink: (payload: {
    bidhiLineId: number;
    bidhiId: number;
    position: number;
    order: number;
    entireBidhi?: boolean;
    selectedBidhiLineIds?: number[];
    titleVisible?: boolean;
    shortcut?: boolean;
    displayName?: string;
  }) => api.post('/bidhi-line-link/multiple-bidhi', payload),
  getMultipleBidhiLinksByBidhiLine: (bidhiLineId: number) =>
    api.get(`/bidhi-line-link/multiple-bidhi/bidhi-line/${bidhiLineId}`),
  updateMultipleBidhiLink: (id: number, payload: Partial<{
    bidhiLineId: number;
    bidhiId: number;
    position: number;
    order: number;
    entireBidhi: boolean;
    selectedBidhiLineIds: number[];
    titleVisible: boolean;
    shortcut: boolean;
    displayName: string;
  }>) => api.patch(`/bidhi-line-link/multiple-bidhi/${id}`, payload),
  bulkUpdateMultipleBidhiLinkOrder: (updates: { bidhiLineMultipleBidhiLinkId: number; changedOrder: number }[]) =>
    api.patch('/bidhi-line-link/multiple-bidhi/bulk-order', updates),
  deleteMultipleBidhiLink: (id: number) =>
    api.delete(`/bidhi-line-link/multiple-bidhi/${id}`),

  createSankalpaLink: (payload: {
    bidhiLineId: number;
    sankalpaId: number;
    position: number;
    entireSankalpa?: boolean;
    selectedSankalpaLineIds?: number[];
    titleVisible?: boolean;
  }) => api.post('/bidhi-line-link/sankalpa', payload),
  getSankalpaLinksByBidhiLine: (bidhiLineId: number) =>
    api.get(`/bidhi-line-link/sankalpa/bidhi-line/${bidhiLineId}`),
  updateSankalpaLink: (id: number, payload: Partial<{
    bidhiLineId: number;
    sankalpaId: number;
    position: number;
    entireSankalpa: boolean;
    selectedSankalpaLineIds: number[];
    titleVisible: boolean;
  }>) => api.patch(`/bidhi-line-link/sankalpa/${id}`, payload),
  deleteSankalpaLink: (id: number) =>
    api.delete(`/bidhi-line-link/sankalpa/${id}`),
};

// Samagri API Calls
export const samagriApi = {
  getAll: () => api.get<Samagri[]>('/karmakanda/samagri'),
  create: (samagri: CreateSamagri | FormData) => {
    if (samagri instanceof FormData) {
      return api.post<Samagri>('/karmakanda/samagri', samagri, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.post<Samagri>('/karmakanda/samagri', samagri);
  },
  update: (id: number, samagri: Partial<CreateSamagri> | FormData) => {
    if (samagri instanceof FormData) {
      return api.patch<Samagri>(`/karmakanda/samagri/${id}`, samagri, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return api.patch<Samagri>(`/karmakanda/samagri/${id}`, samagri);
  },
  delete: (id: number) => api.delete(`/karmakanda/samagri/${id}`),
};

// Bidhi-Samagri Association API Calls
export const bidhiSamagriAssociationApi = {
  create: (payload: { bidhiId: number; samagriId: number; quantity: number; unit: string }) =>
    api.post('/bidhi-samagri-association', payload),
  update: (id: number, payload: { quantity?: number; unit?: string }) =>
    api.patch(`/bidhi-samagri-association/${id}`, payload),
  delete: (id: number) =>
    api.delete(`/bidhi-samagri-association/${id}`),
};

// Puja-Samagri Association API Calls
export const pujaSamagriAssociationApi = {
  create: (payload: { pujaId: number; samagriId: number; quantity: number; unit?: string }) =>
    api.post('/puja-samagri-association', payload),
  update: (id: number, payload: { quantity?: number; unit?: string }) =>
    api.patch(`/puja-samagri-association/${id}`, payload),
  delete: (id: number) =>
    api.delete(`/puja-samagri-association/${id}`),
};

// Panchanga API Calls
const panchangaApiInstance = axios.create({
  baseURL: 'http://104.37.174.214:9000',
});

export const panchangaApi = {
  get: (params: { mode: string; lat: number; lon: number; timezone: string; bs_date: string; time: string }) =>
    panchangaApiInstance.get<Panchanga>('/api/v2/sankalpa', { params }),
};